import selectUsualMinigame from "./SelectTask/selectUsualMinigame";
import getMinigameByName from "./getMinigameByName";

function selectMinigame(config, state, history){
    var task;
    let countArr = [1, 2, 5, 10, 20, 30];
    let history1 = history.filter(hr => hr.type === "task");
    let count = state.objects.count ? state.objects.count : 0;
    const revHistory = history.slice().reverse();
    let curc = history1.filter(hr => (hr.minigame.name !== "final" && hr.minigame.name !== "count-rest")).length;
    let maxc = state.objects.count + config.initMinigames.length;

    if(history.length !== 0 && history[history.length - 1].minigame.name === 'final'){
        if(history[history.length - 1].playerAns === 0) {
            state.objects.endofRound = true;
            return config.service[1];
        }
        else {
            state.objects.endofGame = true;
            return config.service[2];
        }

    }
    else if(history.length !== 0 && history[history.length - 1].minigame.name === 'count-rest'){
        if(state.objects.endofRound){
            state.objects.endofRound = false;
            state.objects.count += countArr[history[history.length - 1].playerAns];
            state.objects.curcount = countArr[history[history.length - 1].playerAns];
        }
    }
    else if(state.objects.init && curc >= maxc && !state.objects.endofRound) {
        return config.service[0];
    } 
    
    if(state.objects.init){
        task = selectUsualMinigame(config, state, history);
    }
    else {
        task = config.initMinigames.map(mg => mg.name)[history.length];
    }

    if(task === undefined){
        return undefined;
    }

    if(config.type === "menu" && task === state.objects.currentMinigame){
        return undefined;
    }

    if(config.type === "subtask"){
        return task;
    }

    let minigame = getMinigameByName(task, config);

    if(minigame === undefined && config.type === "menu"){
        minigame = getMinigameByName(config.minigames[0].name, config)
    }

    return minigame;
}

export default selectMinigame